<p>{{ parentComponentData }}</p>

<!-- <div *ngIf="isArrayFlag">
  <ul>
    <li *ngFor="let item of parentComponentData">
      {{ item }}
    </li>
  </ul>
</div> -->

<div class="modal-footer">
  <button
    type="button"
    class="btn btn-primary"
    data-dismiss="modal"
    (click)="onSave()"
  >
    Yes
  </button>
  <button type="button" (click)="onClose()" class="btn btn-secondary">
    No
  </button>
</div>
